import React, { Component } from 'react';
import { isEmpty } from '../../Common/Common';

export default class Display_PowerSummary_Cell extends Component {
	constructor(props) {
		super(props);

		this.state = {
			total_consumption: this.props.receiver.getString('no_data'),
			ac_consumption: this.props.receiver.getString('no_data'),
		}
	}

	componentDidMount() {
		let start_date = new Date();
		start_date.setMonth(0);
		start_date.setDate(1);
		let end_date = new Date(start_date);
		end_date.setYear(end_date.getFullYear() + 1);

		let points = [...this.props.display_Ac_points];

		let search_details = {
			fy: start_date.getFullYear(),
			fm: start_date.getMonth() + 1,
			fd: start_date.getDate(),
			ty: end_date.getFullYear(),
			tm: end_date.getMonth() + 1,
			td: end_date.getDate(),
			points: this.props.points,
		};

		this.props.receiver.getMonthlyMeter(search_details);

	}

	rcvMonthlyMeter = (monthly_meter) => {
		if (isEmpty(monthly_meter.data)) {

		} else {
			// console.log('monthly_meter.data = ' + JSON.stringify(monthly_meter.data))

			// todo: sum up all data for total_consumption
			// todo: sum up points in this.props.display_Ac_points for ac_consumption
			// todo: setState 
		}
	}

	render() {

		return (
			<div>
				<div>
					<span className='subtitle' style={{ display: 'inline-block' }}>{this.props.receiver.getString('total_consumption') + ': '}</span>
					<span style={{ display: 'inline-block' }}>{this.state.total_consumption}</span>
					<span className='subtitle' style={{ display: 'inline-block' }}>{'kWh'}</span>
				</div>
				<div>
					<span className='subtitle' style={{ display: 'inline-block' }}>{this.props.receiver.getString('ac')}</span>
					<span style={{ display: 'inline-block' }}>{this.state.ac_consumption}</span>
					<span className='subtitle' style={{ display: 'inline-block' }}>{'kWh'}</span>
				</div>
			</div>
		)
	}
}